// extracted by mini-css-extract-plugin
export default {"block":"AvatarManagerControl_block__IN20C","controlsBlock":"AvatarManagerControl_controlsBlock__1+ZtB"};